import { http } from './http'

export function getKitchenUsers () {
  return http.get('/api/kitchen/users')
}

export function createKitchenUser (payload) {
  return http.post('/api/kitchen/users', payload)
}

export function setKitchenUserActive (id, active) {
  return http.put(`/api/kitchen/users/${id}/active`, { active })
}

export function resetKitchenUserPassword (id) {
  return http.post(`/api/kitchen/users/${id}/reset-password`)
}
